import React from 'react';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const TrustSection = () => {
  const { t } = useLanguage();

  const trustFeatures = [
    {
      icon: "Shield",
      title: t('trust.dataProtection'),
      description: t('trust.dataProtectionDesc')
    },
    {
      icon: "Lock",
      title: t('trust.encryptedCommunication'),
      description: t('trust.encryptedCommunicationDesc')
    },
    {
      icon: "ShieldCheck",
      title: t('trust.manualReview'),
      description: t('trust.manualReviewDesc')
    }
  ];

  const certifications = [
    { icon: 'Shield', label: t('trust.soc2') },
    { icon: 'Globe', label: t('trust.gdpr') },
    { icon: 'Award', label: t('trust.iso') },
    { icon: 'CheckCircle', label: t('trust.pipeda') },
    { icon: 'FileCheck', label: t('trust.loi25') }
  ];

  return (
    <section className="py-16 md:py-24 lg:py-32 bg-gradient-to-br from-gray-50 to-blue-50/30">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/60 backdrop-blur-xl border border-white/20 shadow-lg rounded-full mb-4 md:mb-6">
            <Icon name="ShieldCheck" size={20} color="#0025cc" />
            <span className="text-sm md:text-base font-medium text-[#0025cc]">{t('trust.badge')}</span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#111827] mb-4">
            {t('trust.title')}
          </h2>
          <p className="text-base md:text-lg text-[#6B7280] max-w-2xl mx-auto">
            {t('trust.subtitle')}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mb-12 md:mb-16">
          {trustFeatures?.map((feature, index) => (
            <div 
              key={index}
              className="text-center p-6 md:p-8 rounded-3xl bg-white/40 backdrop-blur-xl border border-white/20 shadow-xl hover:shadow-2xl hover:bg-white/50 transition-all duration-300"
              style={{
                background: 'linear-gradient(135deg, rgba(255,255,255,0.4) 0%, rgba(255,255,255,0.2) 100%)'
              }}
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-2xl bg-gradient-to-br from-[#0025cc] to-[#0025cc] flex items-center justify-center mx-auto mb-4 md:mb-6 shadow-lg">
                <Icon name={feature?.icon} size={24} color="#FFFFFF" />
              </div>
              <h3 className="text-base md:text-lg font-semibold text-[#111827] mb-2">
                {feature?.title}
              </h3>
              <p className="text-sm md:text-base text-[#6B7280]">
                {feature?.description}
              </p>
            </div>
          ))}
        </div>
        
        <div className="bg-white/40 backdrop-blur-xl border border-white/20 rounded-3xl p-8 md:p-12 shadow-xl" style={{
          background: 'linear-gradient(135deg, rgba(255,255,255,0.4) 0%, rgba(255,255,255,0.2) 100%)'
        }}>
          <h3 className="text-xl md:text-2xl font-bold text-[#111827] text-center mb-8 md:mb-12">
            {t('trust.certifiedCompliant')}
          </h3>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {certifications?.map((cert, index) => (
              <div 
                key={index}
                className="flex flex-col items-center gap-3 p-4 md:p-6 bg-white/60 backdrop-blur-sm rounded-2xl border border-white/30 shadow-lg hover:shadow-xl transition-all duration-300"
              >
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-gradient-to-br from-[#0025cc]/20 to-[#0025cc]/20 flex items-center justify-center">
                  <Icon name={cert?.icon} size={24} color="#0025cc" />
                </div>
                <span className="text-sm md:text-base font-medium text-[#111827] text-center">
                  {cert?.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;